import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { Reveal } from "../lib/anim";

const FAQS = [
  {
    q: "Why does Geonetix pay you to drive?",
    a: "Accurate map data is the lifeblood of modern mapping firms, logistics operations, and the automotive sector. Instead of relying on expensive survey vehicles, Geonetix partners with everyday drivers to collect hyper-local, real-time street details. We use these contributions to update our very own Geomaps daily, ensuring a better, more accurate mapping future. Because your submissions directly fuel our network and partner industries, we believe you should share in the profit. Every approved route submission earns you real cash toward your fuel expenses, turning your ordinary daily commute into a commercial data partnership.",
  },
  {
    q: "Do I need technical Web3 or crypto wallet knowledge?",
    a: "No. GeoNetix is entirely zero-friction with one-click activation and direct INR bank transfers. There are no wallets, no seed phrases, and no tokens to manage.",
  },
  {
    q: "Does the mapping layer compromise my private information?",
    a: "Never. Only automated, unidentifiable road asset imagery is processed. Faces and license plates are fully scrubbed at the edge — locally on the device — before anything is uploaded.",
  },
  {
    q: "How often are rewards updated?",
    a: "Earnings accumulate every single second your device is active and connected. You can watch your INR balance tick up in real-time inside the app.",
  },
];

export const Faq = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 bg-[#050d1a] border-y border-white/10"
    >
      <div className="max-w-3xl mx-auto px-6">
        <Reveal className="text-center mb-12">
          <p className="font-mono-gx text-xs uppercase tracking-[0.25em] text-[#00B4D8] mb-4">
            / Frequently Asked
          </p>
          <h2 className="font-display font-black text-3xl md:text-5xl tracking-tight leading-[1.1]">
            No fine print. <span className="text-slate-400">Just clarity.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/10"
              >
                <AccordionTrigger className="text-left text-base md:text-lg font-semibold text-slate-100 hover:no-underline hover:text-[#00B4D8] py-6 [&>svg]:text-[#00B4D8]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-400 text-[15px] leading-relaxed pb-6 pr-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
